export default "__VITE_PUBLIC_ASSET__a7c33ab9__"